var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatarAlertBreathRate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hilbi-WebApp-Desktop-Chat_Detail"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Avatar-Default"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Avatar-Phantom"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M33.5 17 C33.5 26.113 26.113 33.5 17 33.5 7.887 33.5 0.5 26.113 0.5 17 0.5 7.887 7.887 0.5 17 0.5 26.113 0.5 33.5 7.887 33.5 17 Z",
    fill: "none",
    stroke: "#ff335d",
    strokeWidth: 1,
    strokeOpacity: 0.297,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "lung-2-copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lung"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M17 9 C17.414 9 17.751 9.334 17.751 9.744 L17.752 13.05 C17.76 13.571 17.854 13.843 18.751 13.843 L18.617 13.839 C18.705 12.055 19.112 10.17 20.724 10.17 23.043 10.17 25 16.238 25 20.049 L24.999 20.191 C24.993 20.795 24.924 23.093 24.227 23.785 24.084 23.928 23.92 24 23.741 24 23.267 24 23.031 23.822 22.704 23.575 22.295 23.265 21.734 22.841 20.312 22.437 18.041 21.792 18.13 19.784 18.37 17.587 L18.416 17.173 C18.485 16.566 18.555 15.942 18.583 15.327 17.916 15.303 17.384 15.136 17 14.828 16.583 15.161 15.994 15.33 15.25 15.33 L15.417 15.327 C15.445 15.942 15.515 16.566 15.584 17.173 15.85 19.528 16.1 21.751 13.688 22.437 12.266 22.841 11.705 23.265 11.296 23.575 10.969 23.822 10.734 24 10.259 24 10.08 24 9.916 23.928 9.773 23.785 9.076 23.093 9.007 20.795 9.001 20.19 L9 20.048 C9 16.238 10.957 10.17 13.276 10.17 14.888 10.17 15.295 12.055 15.383 13.839 16.207 13.811 16.249 13.507 16.249 12.949 L16.249 9.744 C16.249 9.334 16.586 9 17 9 Z",
    fill: "#ff335c",
    fillOpacity: 1,
    stroke: "none"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarAlertBreathRate);
export default __webpack_public_path__ + "static/media/avatar-alert-breath_rate.86860af668b48709c00fb9d5966d2435.svg";
export { ForwardRef as ReactComponent };